import { createAxiosInstance } from './http';

export const sendContactMessage = async (data) => {
  const res = await createAxiosInstance().post('/contact', data);
  return res.data;
};

